package one.healthium.db

import kotlin.Double
import kotlin.Long
import kotlin.String

public data class FoodEntity(
  public val id: Long,
  public val product: String,
  public val emoji: String,
  public val description: String,
  public val calories: Double,
  public val fat: Double,
  public val carbohydrates: Double,
  public val fiber: Double,
  public val protein: Double,
  public val tablespoon: Double?,
  public val cups: Double?,
  public val pieces: Double?,
  public val isLiquid: Long,
)
